// #572: Es gibt nur noch EIN Mailfenster. Jede weitere angeklickte Mail erscheint darin, statt
// ein neues Fenster zu öffnen (vorher stapelten sich die Fenster, eins je Mail). Postfach und
// Mailfenster sprechen über den BroadcastChannel 'immo-emails' (#551).

export const MAIL_FENSTER_NAME = 'immo-mail-fenster';
export const MAIL_FENSTER_MERKMALE = 'popup=yes,width=1080,height=920';
export const mailFensterPfad = (id: string): string => `/mail-fenster/${id}`;

/** Postfach → Mailfenster: diese Mail zeigen. Mailfenster → Postfach: mich schließen (Fallback). */
export type MailFensterNachricht = { typ: 'zeige'; id: string } | { typ: 'schliessen' };

export function alsMailFensterNachricht(daten: unknown): MailFensterNachricht | null {
  if (!daten || typeof daten !== 'object') return null;
  const d = daten as { typ?: unknown; id?: unknown };
  if (d.typ === 'zeige' && typeof d.id === 'string' && d.id) return { typ: 'zeige', id: d.id };
  if (d.typ === 'schliessen') return { typ: 'schliessen' };
  return null;
}
